// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"-xh1QuZ39BPuRmUG-5S8l"};